"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _draftJs = require("draft-js");

var _draftExtend = require("draft-extend");

var _utils = require("draft-plugins/lib/utils");

var _configureFileManager = _interopRequireDefault(require("FileManagerLib/components/configureFileManager"));

var _Constants = require("FileManagerLib/Constants");

var _Drawer = _interopRequireDefault(require("FileManagerLib/components/Drawer"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _userInfo = require("hub-http/userInfo");

var _EditLinkPopoverBody = _interopRequireDefault(require("rich-text-lib/components/links/EditLinkPopoverBody"));

var _InsertLinkPopoverBody = _interopRequireDefault(require("rich-text-lib/components/links/InsertLinkPopoverBody"));

var _popover = require("rich-text-lib/constants/popover");

var _link = require("rich-text-lib/constants/link");

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _PagesClient = require("../api/PagesClient");

var POPOVER_TO_ENTITY_PROPERTY_MAP = {
  externalLink: 'isTargetBlank',
  fileMeta: 'fileMeta',
  href: 'url',
  linkDisplayName: 'linkDisplayName',
  linkText: 'text',
  linkType: 'linkType',
  noFollow: 'isNoFollow'
};

var isAtomicBlockSelected = function isAtomicBlockSelected(editorState) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var selectedBlocks = content.getBlockMap().skipUntil(function (_, blockKey) {
    return blockKey === selection.getStartKey();
  }).takeWhile(function (_, blockKey) {
    return blockKey !== selection.getEndKey();
  }).toList().push(content.getBlockForKey(selection.getEndKey()));
  return !!selectedBlocks.find(function (block) {
    return block.getType() === 'atomic';
  });
};

var textNeedsProtocol = function textNeedsProtocol() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var trimmedUrl = url.trim();
  return trimmedUrl.indexOf('://') === -1 && trimmedUrl.indexOf('tel:') !== 0 && trimmedUrl.indexOf('mailto:') !== 0;
};

var addProtocolToUrl = function addProtocolToUrl(url) {
  var isEmptyString = !url || !url.trim();
  var newUrl = url;

  if (!isEmptyString && textNeedsProtocol(url)) {
    newUrl = "http://" + url;
  }

  return newUrl;
};

var insertNewLinkToEditorState = function insertNewLinkToEditorState(editorState, entityOptions, linkText) {
  var _editorState$getCurre;

  var selection = editorState.getSelection();

  var contentStateWithEntity = (_editorState$getCurre = editorState.getCurrentContent()).createEntity.apply(_editorState$getCurre, (0, _toConsumableArray2.default)(entityOptions));

  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  var modifierMethod = selection.isCollapsed() ? _draftJs.Modifier.insertText : _draftJs.Modifier.replaceText;

  var newEditorState = _draftJs.EditorState.push(editorState, modifierMethod(contentStateWithEntity, selection, linkText, editorState.getCurrentInlineStyle(), entityKey), 'insert-characters');

  return _draftJs.EditorState.forceSelection(newEditorState, newEditorState.getCurrentContent().getSelectionAfter());
};

var getSelectedText = function getSelectedText(editorState) {
  var selection = editorState.getSelection();
  (0, _invariant.default)(selection.getStartKey() === selection.getEndKey(), 'getSelectedText: Called with EditorState whose selection includes more than one block');
  var block = editorState.getCurrentContent().getBlockForKey(selection.getStartKey());
  return block.getText().slice(selection.getStartOffset(), selection.getEndOffset());
};

var _default = function _default(Component) {
  return function (getEntityOptions, _ref) {
    var _class, _temp;

    var showNoFollow = _ref.showNoFollow,
        showTarget = _ref.showTarget,
        onOpenPopover = _ref.onOpenPopover;
    return _temp = _class = /*#__PURE__*/function (_React$Component) {
      (0, _inherits2.default)(_class, _React$Component);

      function _class() {
        var _getPrototypeOf2;

        var _this;

        (0, _classCallCheck2.default)(this, _class);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(_class)).call.apply(_getPrototypeOf2, [this].concat(args)));
        _this.state = _this.hydrateState();

        _this.handleComponentClick = function () {
          var _this$getEditorData = _this.getEditorData(),
              editorState = _this$getEditorData.editorState,
              onChange = _this$getEditorData.onChange;

          var isSelectionCollapsed = editorState.getSelection().isCollapsed();

          if (_this.isNew() && !isSelectionCollapsed) {
            // adding link to existing text via toolbar button so instead
            // of opening a popover in toolbar, insert a link entity and
            // let the new entity's decorator render the popover
            var _this$getInitialFormS = _this.getInitialFormState(),
                fileMeta = _this$getInitialFormS.fileMeta,
                isNoFollow = _this$getInitialFormS.isNoFollow,
                isTargetBlank = _this$getInitialFormS.isTargetBlank,
                linkDisplayName = _this$getInitialFormS.linkDisplayName,
                linkType = _this$getInitialFormS.linkType,
                text = _this$getInitialFormS.text,
                url = _this$getInitialFormS.url;

            var entityOptions = getEntityOptions(addProtocolToUrl(url), isTargetBlank, isNoFollow, linkDisplayName, linkType, fileMeta);
            var newEditorState = insertNewLinkToEditorState(editorState, entityOptions, text);
            var entityKey = newEditorState.getCurrentContent().getLastCreatedEntityKey();

            var entitySelection = _draftExtend.pluginUtils.getEntitySelection(newEditorState, entityKey);

            onChange(_draftJs.EditorState.forceSelection(newEditorState, entitySelection));
          } else {
            _this.setState(function (state) {
              var shouldRestoreFocus = false;

              if (state.open === false) {
                onOpenPopover();

                var selection = _this.getEditorData().editorState.getSelection();

                shouldRestoreFocus = selection.getHasFocus();
              }

              return Object.assign({
                open: !state.open,
                shouldRestoreFocus: shouldRestoreFocus
              }, _this.getInitialFormState());
            });
          }
        };

        _this.updateEntityData = function () {
          var decoratedText = _this.props.decoratedText;
          var _this$state = _this.state,
              fileMeta = _this$state.fileMeta,
              isNoFollow = _this$state.isNoFollow,
              isTargetBlank = _this$state.isTargetBlank,
              linkDisplayName = _this$state.linkDisplayName,
              linkType = _this$state.linkType,
              text = _this$state.text,
              url = _this$state.url;

          var _this$getEditorData2 = _this.getEditorData(),
              editorState = _this$getEditorData2.editorState,
              onChange = _this$getEditorData2.onChange; // LI-197


          var encodedUrl = (0, _utils.encodeUrl)(addProtocolToUrl(url));

          if (_this.isNew()) {
            var entityOptions = getEntityOptions(encodedUrl, isTargetBlank, isNoFollow, linkDisplayName, linkType, fileMeta);
            var newEditorState = insertNewLinkToEditorState(editorState, entityOptions, text);
            onChange(newEditorState);
          } else {
            var entityKey = _this.props.entityKey;

            var entitySelection = _draftExtend.pluginUtils.getEntitySelection(editorState, entityKey);

            var contentState = editorState.getCurrentContent().mergeEntityData(entityKey, {
              isNoFollow: isNoFollow,
              isTargetBlank: isTargetBlank,
              linkDisplayName: linkDisplayName,
              linkType: linkType,
              fileMeta: fileMeta,
              url: encodedUrl
            });

            var updatedEditorState = _draftJs.EditorState.push(editorState, _draftJs.Modifier.applyEntity(contentState, editorState.getSelection(), entityKey), 'update-entity');

            if (text !== decoratedText) {
              var entityStyles = _draftExtend.pluginUtils.getSelectedInlineStyles(_draftJs.EditorState.forceSelection(updatedEditorState, entitySelection));

              onChange(_draftJs.EditorState.push(updatedEditorState, _draftJs.Modifier.replaceText(updatedEditorState.getCurrentContent(), entitySelection, text, entityStyles, entityKey), 'update-entity'));
            } else {
              onChange(updatedEditorState);
            }
          }
        };

        _this.handleClose = function () {
          var url = _this.state.url;

          if (!_this.isNew() && (!url || url.trim().length === 0)) {
            _this.handleRemove();
          } else {
            _this.updateEntityData();
          }

          if (_this.state.shouldRestoreFocus) {
            var _this$getEditorData3 = _this.getEditorData(),
                editorState = _this$getEditorData3.editorState,
                onChange = _this$getEditorData3.onChange;

            onChange(_draftJs.EditorState.forceSelection(editorState, editorState.getSelection()));
          }

          _this.setState(_this.hydrateState());
        };

        _this.handleRemove = function () {
          if (_this.isNew()) {
            return;
          }

          var entityKey = _this.props.entityKey;

          var _this$getEditorData4 = _this.getEditorData(),
              editorState = _this$getEditorData4.editorState,
              onChange = _this$getEditorData4.onChange;

          var selection = _draftExtend.pluginUtils.getEntitySelection(editorState, entityKey);

          onChange(_draftJs.RichUtils.toggleLink(editorState, selection, null));
        };

        _this.handleChange = function (update) {
          // the property names used by rich-text-lib
          // components don't match what is being used
          // for link entities, so we have to do a conversion
          // in the interest of backwards compatibility
          var updateWithConvertedKeys = {};
          Object.keys(update).forEach(function (key) {
            var newKey = POPOVER_TO_ENTITY_PROPERTY_MAP[key];
            updateWithConvertedKeys[newKey] = update[key];
          });

          if (updateWithConvertedKeys.linkType && updateWithConvertedKeys.linkType !== _link.LinkTypes.FILE) {
            updateWithConvertedKeys.fileMeta = undefined;
          }

          _this.setState(updateWithConvertedKeys);
        };

        _this.handleLinkTypeChange = function (linkType) {
          _this.setState({
            linkType: linkType,
            url: '',
            linkDisplayName: '',
            fileMeta: undefined
          });
        };

        _this.handleModeChange = function (popoverMode) {
          _this.setState({
            popoverMode: popoverMode
          });
        };

        _this.handleOpenFileManager = function (callback) {
          _this.setState({
            fileManagerOpen: true,
            onSelectFile: callback
          });
        };

        _this.handleCloseFileManager = function () {
          _this.setState({
            fileManagerOpen: false,
            onSelectFile: null
          });
        };

        _this.handleSelectFile = function (file) {
          _this.state.onSelectFile(file.toJS());

          _this.handleCloseFileManager();
        };

        _this.handlePagesFetch = function (term, offset) {
          return (0, _PagesClient.fetchPagesByTerm)(term, offset);
        };

        _this.handleInsertTextWithLink = function () {
          var _this$state2 = _this.state,
              fileMeta = _this$state2.fileMeta,
              isTargetBlank = _this$state2.isTargetBlank,
              isNoFollow = _this$state2.isNoFollow,
              linkDisplayName = _this$state2.linkDisplayName,
              linkType = _this$state2.linkType,
              text = _this$state2.text,
              url = _this$state2.url;

          var _this$getEditorData5 = _this.getEditorData(),
              editorState = _this$getEditorData5.editorState,
              onChange = _this$getEditorData5.onChange;

          var entityOptions = getEntityOptions(url, isTargetBlank, isNoFollow, linkDisplayName, linkType, fileMeta);
          var newEditorState = insertNewLinkToEditorState(editorState, entityOptions, text);
          onChange(newEditorState);

          _this.setState(_this.hydrateState());
        };

        return _this;
      }

      (0, _createClass2.default)(_class, [{
        key: "UNSAFE_componentWillMount",
        value: function UNSAFE_componentWillMount() {
          this.FileManager = (0, _configureFileManager.default)({
            httpClient: _apiClient.default
          });
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          var decoratedText = this.props.decoratedText;

          var _this$getEditorData6 = this.getEditorData(),
              editorState = _this$getEditorData6.editorState;

          if (decoratedText === getSelectedText(editorState)) {
            // newly-inserted link, let's edit it
            this.setState({
              open: true,
              popoverMode: _popover.PopoverBodyMode.EDIT
            });
          }
        }
      }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
          if (this.isNew()) {
            return;
          }

          var _this$getEditorData7 = this.getEditorData(),
              editorState = _this$getEditorData7.editorState;

          var selection = editorState.getSelection();

          if (selection.getStartKey() !== selection.getEndKey()) {
            return;
          }

          var decoratedText = nextProps.decoratedText;

          if (decoratedText === getSelectedText(editorState)) {
            // newly-inserted link, let's edit it
            this.setState({
              open: true,
              popoverMode: _popover.PopoverBodyMode.EDIT
            });
          }

          var nextEntityKey = nextProps.entityKey;
          var currentEntityKey = this.props.entityKey;

          if (nextEntityKey !== currentEntityKey) {
            this.setState(this.getInitialFormState(nextProps));
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          this.target = (0, _reactDom.findDOMNode)(this._child) || undefined;
        }
      }, {
        key: "hydrateState",
        value: function hydrateState() {
          return Object.assign({
            fileManagerOpen: false,
            open: false,
            onSelectFile: null,
            popoverMode: _popover.PopoverBodyMode.PREVIEW,
            shouldRestoreFocus: false
          }, this.getInitialFormState());
        }
      }, {
        key: "getInitialFormState",
        value: function getInitialFormState() {
          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

          if (this.isNew()) {
            var _this$getEditorData8 = this.getEditorData(),
                editorState = _this$getEditorData8.editorState;

            var text = '';
            var selection = editorState.getSelection();

            if (selection.getStartKey() === selection.getEndKey()) {
              text = getSelectedText(editorState);
            }

            return {
              fileMeta: undefined,
              isNoFollow: showNoFollow,
              isTargetBlank: showTarget,
              text: text,
              url: '',
              linkDisplayName: '',
              linkType: _link.LinkTypes.URL
            };
          }

          var decoratedText = props.decoratedText;

          var _this$getEntity$getDa = this.getEntity(props.entityKey).getData(),
              fileMeta = _this$getEntity$getDa.fileMeta,
              linkDisplayName = _this$getEntity$getDa.linkDisplayName,
              linkType = _this$getEntity$getDa.linkType,
              isNoFollow = _this$getEntity$getDa.isNoFollow,
              isTargetBlank = _this$getEntity$getDa.isTargetBlank,
              url = _this$getEntity$getDa.url;

          return {
            fileMeta: fileMeta,
            isNoFollow: isNoFollow !== undefined ? isNoFollow : showNoFollow,
            isTargetBlank: isTargetBlank !== undefined ? isTargetBlank : showTarget,
            text: decoratedText,
            url: url,
            linkDisplayName: linkDisplayName || url,
            linkType: linkType || _link.LinkTypes.URL
          };
        }
      }, {
        key: "isNew",
        value: function isNew() {
          var entityKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.entityKey;
          return entityKey === undefined;
        }
      }, {
        key: "getEditorData",
        value: function getEditorData() {
          // we need to support both the toolbar case, where this.context
          // is the source of truth, and the inline case, where this.props
          // is the source of truth
          var _this$context = this.context,
              getEditorState = _this$context.getEditorState,
              onChange = _this$context.onChange;

          if (getEditorState && onChange) {
            return {
              editorState: getEditorState(),
              onChange: onChange
            };
          }

          return {
            editorState: this.props.editorState,
            onChange: this.props.onChange
          };
        }
      }, {
        key: "getEntity",
        value: function getEntity() {
          var entityKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.entityKey;

          if (this.isNew(entityKey)) {
            return null;
          }

          var contentState = this.getEditorData().editorState.getCurrentContent();
          return contentState.getEntity(entityKey);
        }
      }, {
        key: "renderFileManager",
        value: function renderFileManager(auth) {
          var _this$state3 = this.state,
              fileManagerOpen = _this$state3.fileManagerOpen,
              onSelectFile = _this$state3.onSelectFile;

          if (!fileManagerOpen || !onSelectFile) {
            return null;
          }

          return _react.default.createElement(this.FileManager, {
            auth: auth
          }, _react.default.createElement(_Drawer.default, {
            onClose: this.handleCloseFileManager,
            onSelect: this.handleSelectFile,
            type: _Constants.DrawerTypes.FILE
          }));
        }
      }, {
        key: "renderPopoverContent",
        value: function renderPopoverContent(auth) {
          var _this2 = this;

          var _this$state4 = this.state,
              fileMeta = _this$state4.fileMeta,
              isNoFollow = _this$state4.isNoFollow,
              isTargetBlank = _this$state4.isTargetBlank,
              linkDisplayName = _this$state4.linkDisplayName,
              linkType = _this$state4.linkType,
              popoverMode = _this$state4.popoverMode,
              text = _this$state4.text,
              url = _this$state4.url;

          var _this$getEditorData9 = this.getEditorData(),
              editorState = _this$getEditorData9.editorState;

          if (isAtomicBlockSelected(editorState)) {
            return null; // atomic blocks have their own popovers
          }

          var sharedProps = {
            externalLink: isTargetBlank,
            fetchPages: this.handlePagesFetch,
            href: url,
            linkType: linkType,
            noFollow: isNoFollow,
            onLinkTypeChange: this.handleLinkTypeChange,
            onSelectFile: this.handleOpenFileManager,
            onUpdate: this.handleChange,
            scopes: auth.user.scopes,
            showRefAndTargetControls: true,
            useEmailSubscription: true
          };

          if (this.isNew()) {
            return _react.default.createElement(_InsertLinkPopoverBody.default, Object.assign({}, sharedProps, {
              canModifyLinkText: true,
              fileMeta: fileMeta,
              linkText: text,
              onClose: function onClose() {
                return _this2.setState({
                  open: false
                });
              },
              onInsert: this.handleInsertTextWithLink
            }));
          }

          return _react.default.createElement(_EditLinkPopoverBody.default, Object.assign({}, sharedProps, {
            currentFileMeta: fileMeta,
            linkDisplayName: linkDisplayName,
            mode: popoverMode,
            onClose: this.handleClose,
            onUnlink: this.handleRemove,
            updateMode: this.handleModeChange
          }));
        }
      }, {
        key: "render",
        value: function render() {
          var _this3 = this;

          var open = this.state.open;
          var auth = (0, _userInfo.userInfoSync)();
          return _react.default.createElement(_UIPopover.default, {
            animateOnToggle: false,
            className: "richtext-link",
            closeOnOutsideClick: true,
            content: this.renderPopoverContent(auth),
            onOpenChange: function onOpenChange(evt) {
              return _this3.setState({
                open: evt.target.value
              });
            },
            open: open,
            pinToConstraint: true,
            target: this.target || undefined
          }, _react.default.createElement("span", null, _react.default.createElement(Component, Object.assign({}, this.props, {
            ref: function ref(c) {
              return _this3._child = c;
            },
            togglePopover: this.handleComponentClick
          })), this.renderFileManager(auth)));
        }
      }]);
      return _class;
    }(_react.default.Component), _class.propTypes = {
      decoratedText: _propTypes.default.string,
      entityKey: _propTypes.default.string,
      editorState: _propTypes.default.object,
      onChange: _propTypes.default.func
    }, _class.contextTypes = {
      getEditorState: _propTypes.default.func,
      onChange: _propTypes.default.func
    }, _temp;
  };
};

exports.default = _default;
module.exports = exports.default;